import compose from 'compose-function';

import { withMantine } from './withMantine';
import { withQuery } from './withQuery';
import { withRouter } from './withRouter';

/**
 * @hoc Инициализирующая логика приложения
 */
export const withProviders = compose(withQuery, withMantine, withRouter);
